import React from 'react';
import PropTypes from 'prop-types';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Are you sure?',
  message = 'This action cannot be undone.',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'danger', // 'danger' or 'warning'
  isLoading = false,
  size = 'sm',
  textAlign = 'center'
}) => {
  if (!isOpen) return null;

  const modalStatusClass = type === 'warning' ? 'bg-warning' : 'bg-danger';
  const textAlignmentClass = textAlign === 'start' ? 'text-start' : 'text-center';
  const dialogSizeClass = size && size !== 'sm' ? `modal-${size}` : 'modal-sm';

  return (
    <>
      <div className="modal modal-blur fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
        <div className={`modal-dialog ${dialogSizeClass} modal-dialog-centered`} role="document">
          <div className="modal-content">
            <div className={`modal-status ${modalStatusClass}`}></div>
            <div className={`modal-body py-4 ${textAlignmentClass}`}>
              <svg xmlns="http://www.w3.org/2000/svg" className={`icon mb-2 text-${type} icon-lg`} width="24" height="24" viewBox="0 0 24 24" 
                strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                {type === 'danger' ? (
                  <>
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M12 9v4" />
                    <path d="M12 17h.01" />
                    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                  </>
                ) : (
                  <>
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                    <path d="M12 8l0 4" />
                    <path d="M12 16l.01 0" />
                  </>
                )}
              </svg>
              <h3>{title}</h3>
              <div className="text-secondary">{message}</div>
            </div>
            <div className="modal-footer">
              <div className="w-100">
                <div className="row">
                  <div className="col">
                    <button className="btn w-100" onClick={onClose} disabled={isLoading}>
                      {cancelText}
                    </button>
                  </div>
                  <div className="col">
                    <button className={`btn btn-${type} w-100`} onClick={onConfirm} disabled={isLoading}>
                      {isLoading ? 'Processing...' : confirmText}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.node,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  type: PropTypes.oneOf(['danger', 'warning']),
  isLoading: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  textAlign: PropTypes.oneOf(['center', 'start'])
};

export default ConfirmationModal; 
